import { AssignmentStatus } from '@/types';
import {
  Calendar,
  FileText,
  Video,
  MessageSquare,
  CheckCircle,
  Clock,
  AlertTriangle,
  Edit,
} from 'lucide-react';

export const getStatusIcon = (status: AssignmentStatus) => {
  switch (status) {
    case 'created':
      return <FileText className='h-4 w-4' />;
    case 'briefing_prepared':
      return <MessageSquare className='h-4 w-4' />;
    case 'interview_scheduled':
      return <Calendar className='h-4 w-4' />;
    case 'interview_in_progress':
      return <Video className='h-4 w-4' />;
    case 'interview_completed':
      return <CheckCircle className='h-4 w-4' />;
    case 'transcript_ready':
      return <FileText className='h-4 w-4' />;
    case 'draft_generated':
      return <Edit className='h-4 w-4' />;
    case 'under_review':
      return <Clock className='h-4 w-4' />;
    case 'approved':
      return <CheckCircle className='h-4 w-4' />;
    case 'published':
      return <CheckCircle className='h-4 w-4' />;
    case 'cancelled':
      return <AlertTriangle className='h-4 w-4' />;
    default:
      return <FileText className='h-4 w-4' />;
  }
};
